import axios from "axios";
import { getFirebaseIdToken } from "@/lib/firebase";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use(async (config) => {
  const token = await getFirebaseIdToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error?.response?.status;
    if (status === 401 && original && !original._retry && !original.url?.includes("/auth/firebase")) {
      original._retry = true;
      try {
        const token = await getFirebaseIdToken(true);
        if (!token) return Promise.reject(error);
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${token}`;
        return client(original);
      } catch {}
    }
    return Promise.reject(error);
  }
);

export default client;
export { BACKEND_URL };
